import Vue from 'vue';
import VueToastr from 'vue-toastr';

Vue.use(VueToastr);
